import { z } from "zod";

export const postPlanDateSchema = z.object({
	date: z.string(),
});
